module.exports = new __parcel__URL__("battleroyale_stardust_icon.becabca3.png").toString();